var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x_circle",
    "data-name": "X Circle",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.967,17.15l-1.9-1.9,1.9-1.9a.576.576,0,0,0-.815-.815l-1.9,1.9-1.9-1.9a.576.576,0,1,0-.815.815l1.9,1.9-1.9,1.9a.557.557,0,0,0,0,.815.572.572,0,0,0,.815,0l1.9-1.9,1.9,1.9a.579.579,0,0,0,.815,0A.572.572,0,0,0,17.967,17.15Z",
    transform: "translate(-4.377 -4.375)",
    fill: "#d60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.875,4.385a6.488,6.488,0,1,1-4.59,1.9,6.447,6.447,0,0,1,4.59-1.9m0-1.01a7.5,7.5,0,1,0,7.5,7.5,7.5,7.5,0,0,0-7.5-7.5Z",
    fill: "#d60000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircle);
export default __webpack_public_path__ + "static/media/x_circle.16b5725bb63c0f48572f2de0c67c26b5.svg";
export { ForwardRef as ReactComponent };